import Image from 'next/image';
import Link from 'next/link';
import { VEHICLES_FOR_HOMEPAGE_CAROUSELResult } from 'sanity.types';

type HomeVehicle = NonNullable<VEHICLES_FOR_HOMEPAGE_CAROUSELResult>[number];

interface CarouselVehicleProps {
    vehicleDetails: HomeVehicle;
}

const CarouselVehicle = ({ vehicleDetails }: CarouselVehicleProps) => {
    return (
        <div
            className=" h-[360px] flex-[0_0_100%]"
            data-testid="carousel-vehicle"
        >
            <div className="h-10 w-[90%] sm:w-3/4 flex justify-center items-center bg-gray-200 rounded-lg mx-auto">
                {vehicleDetails.title}
            </div>
            <Link
                href={vehicleDetails.currentSlug as string}
                className="w-full flex justify-center items-center h-[300px] md:my-8"
                title="Click to see more details about this vehicle"
            >
                <Image
                    unoptimized={true}
                    src={vehicleDetails.imageUrl as string}
                    className="object-contain mx-4"
                    alt="alt"
                    sizes="90vw"
                    width={0}
                    height={0}
                    style={{
                        width: '100%',
                        height: 'auto',
                        maxHeight: '310px',
                    }}
                />
            </Link>
            <div className="pb-4 border-y border-y-gray-300 pt-4 flex justify-around items-center">
                <div className="text-2xl font-bold">
                    £{vehicleDetails?.vehicleHireProps?.pricePerDay}/day
                </div>
                <div className="text-2xl font-bold">
                    £{vehicleDetails?.vehicleHireProps?.pricePerWeek}/week
                </div>
            </div>
        </div>
    );
};

export default CarouselVehicle;
